import { observer } from 'mobx-react';
import { FC } from 'react';
import { ordersRatingStore } from '../../store/ordersRatingStore';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import { LoadingStatus } from '~/types/main';
import '../style.scss';

const OrdersRatingExport: FC = observer((): JSX.Element => {
  return (
    <Button
      className="orders-rating-header__export-button"
      title={localeStore.t('export_to_excel')}
      onClick={ordersRatingStore.exportDocument}
      loading={ordersRatingStore.exportLoadingStatus === LoadingStatus.Loading}
      appearance="secondary"
    />
  );
});

export default OrdersRatingExport;
